/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SocialLoginMicrosoftToken } from './SocialLoginMicrosoftToken';
export type SocialLoginRequest = {
  provider: SocialLoginRequest.provider;
  credential?: string;
  id_token?: SocialLoginMicrosoftToken;
};
export namespace SocialLoginRequest {
  export enum provider {
    GOOGLE = 'google',
    MICROSOFT = 'microsoft',
  }
}

